import styled from 'styled-components'

export const StyledFormBannerWrapper = styled.div`
  > * {
    background-color: transparent !important;
  }
`
